import { ActionTree } from "vuex";
import { UserDataState, RootState } from "@/store/types";
import { CastApi } from "@/adapter/castApi";
import { GuestApi } from "@/adapter/guestApi";

const actions: ActionTree<UserDataState, RootState> = {
  setUserData({ commit }, data) {
    commit("setUserData", data);
  },
  clearUserData({ commit }) {
    commit("clearUserData");
  },
  async setCastData({ commit }) {
    const casts = new CastApi();
    const casrData = await casts.getUserInfo(false);
    commit("setUserData", casrData.data);
  },
  async setGuestData({ commit }) {
    const guests = new GuestApi();
    const guestData = await guests.getUserInfo(false);
    commit("setUserData", guestData.data);
  },
  isApproval({ state }) {
    const data = state.userData;
    if (data == null) {
      return false;
    }
    if (data.isApproval) {
      return true;
    }
    return false;
  },
};

export default actions;
